<template>
  <ion-page>
    <master-layout pageTitle="درخواست فروش ضایعات">
      <ion-card>
        <ion-card-content>
          <div>
            <div class="table-responsive ">
              <table class="table">
                <thead>
                <tr>
                  <th>ضایعات</th>
                  <th>مقدار موجود</th>
                  <th>مقدار</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in a_wastage" :key="index">
                  <td>
                    <div  class="custom-control custom-checkbox mb-3 mt-2">
                      <input value="1" autocomplete="off"
                             type="checkbox"
                             @change="addIsChecked(index)"
                             :checked="item.isChecked"
                             class="custom-control-input"
                             :id="'customCheck'+index" name="in_local">
                      &nbsp;<label class="custom-control-label" :for="'customCheck'+index">{{item.title}}</label>
                    </div>
                  </td>
                  <td>
                    {{item.amount}}&nbsp;{{item.unit}}
                  </td>
                  <td>
                    <div>
                      <input :disabled="!item.isChecked" v-model="item.req_amount" type="tel" name="amount" class="form-control">
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
            <ion-button @click="submitRequest" color="success" type="submit" expand="full">ثبت درخواست</ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue';
import {showSystemNoti} from "@/shared/helper";
import {mapActions} from "vuex";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    IonPage,
  },
  data()
  {
    return {
      id: null,
      a_wastage : []
    }
  },
  async created()
  {

  },
  async mounted()
  {
    const check = await this.getAllAutoWastage();
    if (check.ok)
    {
      this.a_wastage = check.wastages;
    }
  },
  methods: {
    addCallback(result){
      const self = this;
      if (!result.ok){
        showSystemNoti('danger',result.error);
      }
      else
        showSystemNoti('success',result.message,function ()
        {
          self.$router.push({path: '/WastageSellRequest/Manage'});
        });
    },
    ...mapActions("app", {
      getAllAutoWastage: 'getAllAutoWastage',
      submitWastageSellRequest: 'submitWastageSellRequest',
    }),
    addIsChecked(index)
    {
      const item = this.a_wastage[index];
      item.isChecked = !item.isChecked;
    },
    async submitRequest()
    {
      const self = this;
      const out = [];
      const a_wastage = this.a_wastage;
      for (let i = 0; i < a_wastage.length; i++)
      {
        const item = a_wastage[i];
        if (item.isChecked)
        {
          if (item.req_amount )
          {
            if (!isNaN(item.req_amount))
            {
              const out_item = {};
              out_item._id = item._id;
              out_item.amount = item.req_amount;
              out.push(out_item);
            }
            else
              return showSystemNoti('danger','مقادیر درخواستی را باید عدد وارد کنید.');
          }
          else
            return showSystemNoti('danger','مقادیر درخواستی را باید عدد وارد کنید.');
        }
      }
      const check = await this.submitWastageSellRequest(out);
      if (check.ok)
      {
        return showSystemNoti('success',check.message,function (){
          self.$router.push({path: '/WastageSellRequest/Manage'})
        })
      }
      else
        return showSystemNoti('danger',check.error);

    }
  }
}

</script>

<style scoped>
.h6 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
.checkbox2
{
  direction: ltr;
}
</style>